"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicColumnConfigProvider = exports.defineColumnHandler = void 0;
const react_1 = __importDefault(require("react"));
function defineColumnHandler(handlerDef) {
    return handlerDef;
}
exports.defineColumnHandler = defineColumnHandler;
const defaultHandlers = [
    defineColumnHandler({
        name: 'string',
        label: 'String',
        columnType: 'string',
        arrayColumnType: 'string-array',
        format: (columnValue) => columnValue,
        formatArray: (columnValue) => columnValue === null || columnValue === void 0 ? void 0 : columnValue.join('; '),
    }),
    defineColumnHandler({
        name: 'number',
        label: 'Number',
        columnType: 'number',
        arrayColumnType: 'number-array',
        format: (columnValue) => columnValue,
        formatArray: (columnValue) => columnValue === null || columnValue === void 0 ? void 0 : columnValue.join('; '),
    }),
    defineColumnHandler({
        name: 'boolean',
        label: 'Boolean',
        columnType: 'boolean',
        format: (columnValue) => (typeof columnValue === 'boolean' ? (columnValue ? 'Yes' : 'No') : undefined),
    }),
    defineColumnHandler({
        name: 'date',
        label: 'Date',
        columnType: 'number',
        arrayColumnType: 'number-array',
        format: (columnValue) => (columnValue ? new Date(columnValue).toLocaleDateString() : undefined),
        formatArray: (columnValue) => columnValue === null || columnValue === void 0 ? void 0 : columnValue.map((val) => new Date(val).toLocaleDateString()).join('; '),
    }),
];
const DynamicColumnConfigContext = react_1.default.createContext({});
const DynamicColumnConfigProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    let handlers = defaultHandlers;
    if (typeof props.columnHandlers === 'function') {
        handlers = props.columnHandlers(defaultHandlers);
    }
    else if (Array.isArray(props.columnHandlers)) {
        handlers = props.columnHandlers;
    }
    const ctxValue = {
        columnHandlers: handlers,
    };
    return react_1.default.createElement(DynamicColumnConfigContext.Provider, { value: ctxValue }, children);
};
exports.DynamicColumnConfigProvider = DynamicColumnConfigProvider;
exports.default = DynamicColumnConfigContext;
